import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { BaseRules, TextValues } from './massachusetts.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import {
  PersonalInjuryProtectionSelection,
} from '../../../config/pip-constants';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-massachusetts',
  templateUrl: './massachusetts.component.html',
  styleUrls: ['./massachusetts.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
})
export class MassachusettsComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: import('@angular/forms').FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('massachusetts', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('massachusetts', null);
    }
  }
  override dynamicRuleQueryBuilder(): string {
    // 'ShowAllOptions'
    if (
      this.baseRulesService.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.IndividualStateCoverage ||
      this.baseRulesService.personalInjuryProtectionSelection ===
        PersonalInjuryProtectionSelection.AcceptCoverage
    ) {
      return 'ShowAllOptions';
    }
  }
}
